import StopNumberOfItemsCell from './container';

export default StopNumberOfItemsCell;
